import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ERROR_ACTION, WAIT_FOR_ACTION } from 'redux-wait-for-action';
import { ConstantsUtil } from '@utils';
import { FETCH_USER_FAILURE, FETCH_USER_REQUEST, FETCH_USER_ROLE_FAILURE, FETCH_USER_ROLE_REQUEST, FETCH_USER_ROLE_SUCCESS, FETCH_USER_SUCCESS, LOGIN_USER_FAILURE, LOGIN_USER_REQUEST, LOGIN_USER_SUCCESS, LOGOUT_USER_FAILURE, LOGOUT_USER_REQUEST, LOGOUT_USER_SUCCESS } from './auth.action-types';
export var actions = {
  /**
   * Fetch user request action.
   *
   * @author Mikhail Siutsou
   * @function fetchUserRequest
   * @category Actions
   * @subcategory Auth
   * @param {string} token JWT token.
   * @return {fetchUserRequest} fetch user request.
   */
  fetchUserRequest: function fetchUserRequest(id) {
    var _ref;

    return _ref = {
      type: FETCH_USER_REQUEST,
      payload: {
        id: id
      }
    }, _defineProperty(_ref, WAIT_FOR_ACTION, "".concat(FETCH_USER_REQUEST, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS)), _defineProperty(_ref, ERROR_ACTION, "".concat(FETCH_USER_REQUEST, "/").concat(ConstantsUtil.actions.ASYNC_FAILED)), _ref;
  },

  /**
   * Fetch user request success action.
   *
   * @author Mikhail Siutsou
   * @function fetchUserSuccess
   * @category Actions
   * @subcategory Auth
   * @param {FetchUserSuccessPayload} payload payload.
   * @return {fetchUserSuccess} fetch user success.
   */
  fetchUserSuccess: function fetchUserSuccess(payload) {
    return {
      type: FETCH_USER_SUCCESS,
      payload: payload
    };
  },

  /**
   * Fetch user request failure action.
   *
   * @author Mikhail Siutsou
   * @function fetchUserFailure
   * @category Actions
   * @subcategory Auth
   * @param {FetchUserFailurePayload} payload payload.
   * @return {fetchUserFailure} fetch user request failure.
   */
  fetchUserFailure: function fetchUserFailure(payload) {
    return {
      type: FETCH_USER_FAILURE,
      payload: payload
    };
  },

  /**
   * Login user request action.
   *
   * @author Mikhail Siutsou
   * @function loginUserRequest
   * @category Actions
   * @subcategory Auth
   * @param {LoginFormValues} values login form values.
   * @return {loginUserRequest} login user request.
   */
  loginUserRequest: function loginUserRequest(values) {
    return {
      type: LOGIN_USER_REQUEST,
      payload: {
        values: values
      }
    };
  },

  /**
   * Login user request success action.
   *
   * @author Mikhail Siutsou
   * @function loginUserSuccess
   * @category Actions
   * @subcategory Auth
   * @param {LoginUserSuccessPayload} payload payload.
   * @return {loginUserSuccess} login user success.
   */
  loginUserSuccess: function loginUserSuccess(payload) {
    return {
      type: LOGIN_USER_SUCCESS,
      payload: payload
    };
  },

  /**
   * Login user request failure action.
   *
   * @author Mikhail Siutsou
   * @function loginUserFailure
   * @category Actions
   * @subcategory Auth
   * @param {LoginUserFailurePayload} payload payload.
   * @return {loginUserFailure} login user request failure.
   */
  loginUserFailure: function loginUserFailure(payload) {
    return {
      type: LOGIN_USER_FAILURE,
      payload: payload
    };
  },

  /**
   * Logout user request action.
   *
   * @author Mikhail Siutsou
   * @function logoutUserRequest
   * @category Actions
   * @subcategory Auth
   * @return {logoutUserRequest} logout user request.
   */
  logoutUserRequest: function logoutUserRequest() {
    return {
      type: LOGOUT_USER_REQUEST
    };
  },

  /**
   * Logout user request success action.
   *
   * @author Mikhail Siutsou
   * @function logoutUserSuccess
   * @category Actions
   * @subcategory Auth
   * @return {logoutUserSuccess} logout user success.
   */
  logoutUserSuccess: function logoutUserSuccess() {
    return {
      type: LOGOUT_USER_SUCCESS
    };
  },

  /**
   * Logout user request failure action.
   *
   * @author Mikhail Siutsou
   * @function logoutUserFailure
   * @category Actions
   * @subcategory Auth
   * @param {LogoutUserFailurePayload} payload payload.
   * @return {logoutUserFailure} login user request failure.
   */
  logoutUserFailure: function logoutUserFailure(payload) {
    return {
      type: LOGOUT_USER_FAILURE,
      payload: payload
    };
  },

  /**
   * Fetch user role action.
   *
   * @author Ihar Kazlouski
   * @function fetchUserRoleRequest
   * @category Actions
   * @subcategory Auth
   * @param {string} id user id.
   * @return {fetchUserRoleRequest} fetch role request.
   */
  fetchUserRoleRequest: function fetchUserRoleRequest(id) {
    var _ref2;

    return _ref2 = {
      type: FETCH_USER_ROLE_REQUEST,
      payload: {
        id: id
      }
    }, _defineProperty(_ref2, WAIT_FOR_ACTION, "".concat(FETCH_USER_ROLE_REQUEST, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS)), _defineProperty(_ref2, ERROR_ACTION, "".concat(FETCH_USER_ROLE_REQUEST, "/").concat(ConstantsUtil.actions.ASYNC_FAILED)), _ref2;
  },

  /**
   * Fetch user request success action.
   *
   * @author Ihar Kazlouski
   * @function fetchUserRoleSuccess
   * @category Actions
   * @subcategory Auth
   * @param {FetchUserRoleSuccessPayload} payload payload.
   * @return {fetchUserRoleSuccess} fetch user success.
   */
  fetchUserRoleSuccess: function fetchUserRoleSuccess(payload) {
    return {
      type: FETCH_USER_ROLE_SUCCESS,
      payload: payload
    };
  },

  /**
   * Fetch user role request failure action.
   *
   * @author Ihar Kazlouski
   * @function fetchUserRoleFailure
   * @category Actions
   * @subcategory Auth
   * @param {FetchUserRoleFailurePayload} payload payload.
   * @return {fetchUserFailure} fetch user role request failure.
   */
  fetchUserRoleFailure: function fetchUserRoleFailure(payload) {
    return {
      type: FETCH_USER_ROLE_FAILURE,
      payload: payload
    };
  }
};